var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "notification-warning_svg__a",
    d: "M15.582 10.493l-5.295-9.17A2.649 2.649 0 007.997 0c-.94 0-1.818.507-2.289 1.323L.353 10.597a2.653 2.653 0 000 2.644 2.653 2.653 0 002.29 1.323h10.713l.022-.001A2.647 2.647 0 0016 11.919c0-.509-.145-1-.418-1.426zM7.07 3.36h1.96c.149 0 .27.09.27.203l-.54 5.582c0 .112-.122.203-.27.203h-.88c-.148 0-.27-.09-.27-.203L6.8 3.563c0-.112.121-.203.27-.203zM8 12.72a1.28 1.28 0 110-2.56 1.28 1.28 0 010 2.56z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#E64D5F",
    xlinkHref: "#notification-warning_svg__a",
    transform: "translate(0 1)",
    fillRule: "evenodd"
  })));
}
export default SvgNotificationWarning;